import type { LocaleCode, OpsCenterCopy } from "../OpsCenter.Types";
import enMessages from "./messages/en/opsCenter.json";
import esMessages from "./messages/es/opsCenter.json";
import ruMessages from "./messages/ru/opsCenter.json";

export const SUPPORTED_LOCALES = ["en", "es", "ru"] as const satisfies readonly LocaleCode[];

const messages: Record<LocaleCode, OpsCenterCopy> = {
  en: enMessages as unknown as OpsCenterCopy,
  es: esMessages as unknown as OpsCenterCopy,
  ru: ruMessages as unknown as OpsCenterCopy
};

export function resolveLocale(localeSource: string | null | undefined): LocaleCode {
  const normalized = String(localeSource ?? "en").toLowerCase();
  if (normalized.startsWith("es")) {
    return "es";
  }
  if (normalized.startsWith("ru")) {
    return "ru";
  }
  return "en";
}

export function opsCenterCopy(locale: LocaleCode): OpsCenterCopy {
  return messages[locale] ?? messages.en;
}

export function humanize(value: string): string {
  return value.replaceAll("_", " ").replaceAll(".", " / ");
}

export function readableError(error: unknown): string {
  const message = error instanceof Error ? error.message : "request_failed";
  return humanize(message);
}

export function localizedEvidenceText(copy: OpsCenterCopy, value: string | null | undefined): string {
  if (!value) {
    return "";
  }
  const fallbackEvidence = messages.en.evidence as Record<string, string> | undefined;
  return copy.evidence?.[value] ?? fallbackEvidence?.[value] ?? value;
}

export function statusLabel(copy: OpsCenterCopy, statusKey: string): string {
  const fallbackStatus = messages.en.status as Record<string, string> | undefined;
  return copy.status?.[statusKey] ?? fallbackStatus?.[statusKey] ?? humanize(statusKey);
}

